import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74102a4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 新农贷款项会自动打款到极飞代理商账户，申请贷款前请联系代理商确认并向其获取其验证码。 ", -1))
const _hoisted_3 = { class: "van-hairline--bottom field-wrap" }

import { Field } from 'vant'
import { useRouter } from 'vue-router'
import { showConfirmModal } from '@/utils/tools'
import { withDefaults, ref } from 'vue'
import { AgriculturalLoanDeviceListRouteName } from '@/defination/constant'
import { useArgiculturaLoanKeepAliveControll } from '@/compositions/agricultura-loan/index'
import appHost from '@/utils/app'
import PopupWrap from '@/components/popup/common-wrap.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'distributor-verify-code',
  props: {
    visible: { type: Boolean, default: false },
    code: { default: '' }
  },
  emits: ['update:visible', 'confirm', 'update:code'],
  setup(__props: any, { emit: emits }) {

const props = __props as { visible: boolean, code: string };


const $router = useRouter()

const { removeContractListKeepAlive } = useArgiculturaLoanKeepAliveControll()

function updateShowHandle(visible: boolean) {
  emits('update:visible', visible)
}
// 输入值改变
function valueChangeHandle(value: string) {
  console.log('value', value)
  emits('update:code', value)
}
// 确认添加
async function confirmInput() {
  emits('confirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupWrap, {
    show: props.visible,
    "safe-area-inset-bottom": "",
    title: "分经销商验证码",
    headerStyle: {
      backgroundColor: 'white',
    },
    "onUpdate:show": updateShowHandle
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(Field), {
            "model-value": props.code,
            placeholder: "请输入分经销商验证码",
            class: "verify-code-field",
            "onUpdate:modelValue": valueChangeHandle
          }, null, 8, ["model-value"])
        ])
      ]),
      _createVNode(CommonFooterNextButton, {
        title: "确定",
        onClick: confirmInput
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})